import { useEffect, useState } from "react";
import { axiosClient } from "../api/proxy/AxiosClient";
import Users from "./Users";
import { useServices } from "../services/ServiceContext";

export default function Teachers() {
  
  const user = JSON.parse(localStorage.getItem("user"));

  const [teachers, setTeachers] = useState([]);
  //initial mode state
  const [mode, setMode] = useState("empty");
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const { lesson } = useServices();

  useEffect(() => {
    axiosClient
      .get("/students/teachers")
      .then((res) => {
         setTeachers(res.data);
         setSelectedTeacher(res.data?.[0]);
      })
      .catch((err) => console.error("Error fetching teachers", err));
  }, []);

  const addTeacher = async (teacher) => {
    await axiosClient.post(`students/${user.uid}/teachers/${teacher.uid}`);
    setTeachers([...teachers, teacher]);
    setSelectedTeacher(teacher);
    setMode("view");
  }

  const actions = [
    {
      label: "Request Lesson",
      active: () => !user.isDemo && mode !== "create" && selectedTeacher,
      color: "#006600", //green
      handler: () => {
        lesson.openCreateLessonForStudent(selectedTeacher, [selectedTeacher]);
      },
    },
    {
      label: "Add Teacher",
      active: () => !user.isDemo && !selectedTeacher,
      color: "#0000FF",// blue
      handler: () => {
        console.log("Add Teacher clicked:");
        setMode("create");
        setSelectedTeacher(null);
      },
    },
  ];

  return (
    <Users
      mode={mode}
      setMode={setMode}
      initialUsers={teachers}
      selectedUser={selectedTeacher}
      setSelectedUser={setSelectedTeacher}
      actions={actions}
      addUser={addTeacher}
      selectOrAddMessage={'Select or Add Teacher'}
      isSuperuser={user.type === 'superuser'}
    />
  );
}
